import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import type { SubcampaignState } from 'types';

applyTranslations(require('./subcampaigns-empty-message.i18n.json'));

import './subcampaigns-empty-message.scss';

type Props = {
  subcampaignState: SubcampaignState,
  canEdit: boolean
};

const SubcampaignsEmptyMessage = ({
  subcampaignState,
  canEdit
}: Props) => (
  <div className="subcampaigns-empty-message">
    {
      (canEdit)
        ? __t(`subcampaigns_empty_message.default.empty_message_${subcampaignState}`)
        : __t(`subcampaigns_empty_message.blocked.empty_message_${subcampaignState}`)
    }
  </div>
);

export default SubcampaignsEmptyMessage;
